export const UPDATE_ORDER_MESSAGE_LIST = 'UPDATE_ORDER_MESSAGE_LIST';
export const DELETE_MILESTONE_MESSAGE = 'DELETE_MILESTONE_MESSAGE';
export class NexsysOrderMessageModel {
	id?: string;
	status?: string;
	origin?: string;
	message?: string;
	sendConfirmationToOrigin: boolean;

	constructor() {
		this.id = null;
		this.status = null;
		this.origin = null;
		this.message = null;
	}
}
